import { createClient } from '@supabase/supabase-js'

const fallbackUrl = 'https://sovmvhxyfliymqmhhdjm.supabase.co'
const fallbackPublishableKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvdm12aHh5ZmxpeW1xbWhoZGptIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTYzNTk3NTAsImV4cCI6MjA3MTkzNTc1MH0.3NKJa57CFKsLENBQug0hqRe0uKuVRv50n-8uqQms_xs'

export const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || fallbackUrl
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || fallbackPublishableKey

export const supabase = createClient(supabaseUrl, publishableKey, {
  auth: {
    flowType: 'pkce',
    detectSessionInUrl: true,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    headers: { 'x-client-info': 'guve-cms' },
  },
})
